import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "app-clear-graph",
  templateUrl: "./clear-graph.component.html",
  styleUrls: ["./clear-graph.component.scss"]
})
export class ClearGraphComponent implements OnInit {
  @Input() condition: string = "new";

  constructor() { }

  ngOnInit() { }

}
